const root = document.getElementById('tav-compare-root');
if (root) {
  const strings = JSON.parse(root.dataset.strings);
  const key = 'tav-studio-comparison-v2';
  let observedPreview;
  const previewSize = new ResizeObserver(entries => {
    root.style.setProperty('--tav-preview-offset', Math.min(120, entries[0].target.getBoundingClientRect().height) + 'px');
  });
  const watchPreview = () => {
    const preview = document.getElementById('PBarNextFrame');
    if (preview && preview !== observedPreview) {
      observedPreview = preview;
      previewSize.observe(preview);
    }
  };
  watchPreview();
  new MutationObserver(watchPreview).observe(document.body, { childList: true });
  const dialog = root.querySelector('dialog');
  const tray = root.querySelector('[data-compare-tray]');
  const status = root.querySelector('[data-compare-status]');
  const openButton = root.querySelector('[data-compare-open]');
  let selection = [];
  let lastTrigger;
  let messageTimer;
  try {
    const saved = JSON.parse(sessionStorage.getItem(key) || '[]');
    selection = Array.isArray(saved) ? saved.filter(p => p && typeof p.title === 'string' && p.fields && p.id).slice(0, 3) : [];
  } catch {}
  const make = (tag, className, text) => {
    const element = document.createElement(tag);
    if (className) element.className = className;
    if (text !== undefined) element.textContent = text;
    return element;
  };
  const announce = message => {
    clearTimeout(messageTimer);
    status.textContent = message;
    status.classList.add('is-visible');
    messageTimer = setTimeout(() => status.classList.remove('is-visible'), 4500);
  };
  const safeLink = value => {
    try {
      const url = new URL(value, location.origin);
      return url.origin === location.origin ? url.pathname + url.search : '#';
    } catch { return '#'; }
  };
  const safeImage = value => {
    try {
      const url = new URL(value, location.origin);
      return url.protocol === 'https:' && (url.origin === location.origin || url.hostname === 'cdn.shopify.com') ? url.href : '';
    } catch { return ''; }
  };
  const renderTable = () => {
    const table = make('table', 'tav-compare-table');
    const caption = make('caption', 'tav-visually-hidden', strings.ui.heading);
    table.append(caption);
    const head = make('thead');
    const header = make('tr');
    const corner = make('th', 'tav-compare-table__corner', strings.ui.selection);
    corner.scope = 'col';
    header.append(corner);
    selection.forEach(product => {
      const cell = make('th', 'tav-compare-table__product');
      cell.scope = 'col';
      const image = make('img');
      const imageUrl = safeImage(product.image);
      if (imageUrl) {
        image.src = imageUrl;
        image.alt = product.title;
        image.width = 220;
        image.height = 180;
        cell.append(image);
      }
      const title = make('a', 'tav-compare-product-title', product.title);
      title.href = safeLink(product.url);
      cell.append(title, make('p', 'tav-compare-product-price', `${product.price_varies ? strings.ui.from + ' ' : ''}${product.price}`));
      const view = make('a', 'tav-link', strings.ui.view);
      view.append(root.querySelector('[data-compare-arrow]').content.cloneNode(true));
      view.href = safeLink(product.url);
      const remove = make('button', 'tav-compare-remove', strings.ui.remove);
      remove.type = 'button';
      remove.dataset.compareRemove = String(product.id);
      remove.setAttribute('aria-label', `${strings.ui.remove} ${product.title}`);
      cell.append(view, remove);
      header.append(cell);
    });
    head.append(header);
    table.append(head);
    const body = make('tbody');
    Object.entries(strings.fields).forEach(([field, label]) => {
      if (!selection.some(product => product.fields[field])) return;
      const row = make('tr');
      const heading = make('th', '', label);
      heading.scope = 'row';
      row.append(heading);
      selection.forEach(product => row.append(make('td', product.fields[field] ? '' : 'is-missing', product.fields[field] || strings.ui.missing)));
      body.append(row);
    });
    table.append(body);
    root.querySelector('[data-compare-table]').replaceChildren(table);
  };
  const render = () => {
    // Keep saved comparisons in sync with the product names rendered on this page.
    const currentProducts = new Map();
    document.querySelectorAll('[data-tav-compare]').forEach(button => {
      try {
        const product = JSON.parse(button.dataset.product);
        if (product && product.id) currentProducts.set(String(product.id), product);
      } catch {}
    });
    selection = selection.map(product => currentProducts.get(String(product.id)) || product);
    tray.hidden = selection.length === 0;
    root.querySelector('[data-compare-count]').textContent = `${selection.length} / 3 · ${strings.ui.selection}`;
    openButton.disabled = selection.length < 2;
    openButton.title = selection.length < 2 ? strings.ui.min : '';
    const chips = root.querySelector('[data-compare-chips]');
    chips.replaceChildren();
    selection.forEach(product => {
      const chip = make('button', 'tav-compare-chip', product.title + ' ×');
      chip.type = 'button';
      chip.dataset.compareRemove = String(product.id);
      chip.setAttribute('aria-label', `${strings.ui.remove} ${product.title}`);
      chips.append(chip);
    });
    document.querySelectorAll('[data-tav-compare]').forEach(button => {
      try {
        const product = JSON.parse(button.dataset.product);
        const selected = selection.some(item => String(item.id) === String(product.id));
        button.setAttribute('aria-pressed', String(selected));
        button.querySelector('[data-tav-compare-label]').textContent = selected ? strings.ui.selected : strings.ui.add;
        button.querySelector('.tav-compare-check').textContent = selected ? '✓' : '+';
      } catch {}
    });
    try { sessionStorage.setItem(key, JSON.stringify(selection)); } catch {}
    if (dialog.open) {
      if (selection.length < 2) dialog.close();
      else renderTable();
    }
  };
  document.addEventListener('click', event => {
    if (!(event.target instanceof Element)) return;
    const toggle = event.target.closest('[data-tav-compare]');
    if (toggle) {
      event.preventDefault();
      event.stopPropagation();
      let product;
      try { product = JSON.parse(toggle.dataset.product); } catch { return; }
      const index = selection.findIndex(item => String(item.id) === String(product.id));
      if (index >= 0) {
        selection.splice(index, 1);
        announce(strings.ui.removed);
      } else {
        if (selection.length === 3) { announce(strings.ui.limit); return; }
        selection.push(product);
        announce(selection.length === 1 ? strings.ui.added + ' ' + strings.ui.min : strings.ui.added);
      }
      render();
      return;
    }
    const remove = event.target.closest('[data-compare-remove]');
    if (remove) {
      selection = selection.filter(item => String(item.id) !== remove.dataset.compareRemove);
      render();
      announce(strings.ui.removed);
    }
    if (event.target.closest('[data-compare-clear]')) { selection = []; render(); }
    if (event.target.closest('[data-compare-open]')) {
      if (selection.length < 2) { announce(strings.ui.min); return; }
      lastTrigger = event.target.closest('button');
      renderTable();
      dialog.showModal();
    }
    if (event.target.closest('[data-compare-close]')) dialog.close();
    if (event.target === dialog) {
      const rect = dialog.getBoundingClientRect();
      if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) dialog.close();
    }
  });
  dialog.addEventListener('close', () => lastTrigger?.focus());
  document.addEventListener('shopify:section:load', render);
  const grid = document.querySelector('[data-ref="main-collection-products"]');
  if (grid) new MutationObserver(render).observe(grid, { childList: true });
  render();
}


